module.exports = __webpack_public_path__ + "img/529.d52f0c36.jpg";